module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[41]162.6c04801.woff2";